import { logger } from '@adornis/base/logging.js';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { registerServerLogger } from '@adornis/baseql/utils/logger.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { disableAutomaticScrollTop } from '@adornis/chemistry/viewport.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import '@adornis/fonts/fonts.js';
import { currentUser, subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { famedThemeDefinition, fsppThemeDefinition } from '@ils/theme/theme.js';
import '@ils/translation/translation.js';
import Tracker from '@openreplay/tracker';
import { Settings } from 'luxon';
import { distinctUntilChanged } from 'rxjs';
import '../client/global-state.js';
import { ILSUser } from '../db/ils-user.js';
import '../db/index.js';

DesignSystem.setTheme('famed', famedThemeDefinition);
DesignSystem.setTheme('fspp', fsppThemeDefinition);
DesignSystem.useTheme('famed');

const startup = async () => {
  disableAutomaticScrollTop();
  registerServerLogger();

  globalThis.logger = logger;
  Settings.defaultLocale = 'de';
  Settings.defaultZone = 'Europe/Berlin';

  BaseQLClient.initDefault();

  await subscribeCurrentUser(() => ILSUser.allFields);

  if (baseConfig.get('DEPLOYMENT') === 'production') {
    const tracker = new Tracker({
      projectKey: 'CrAD5IBsSV8xrdVsm97i',
      ingestPoint: 'https://openreplay.adornis.de/ingest',
    });
    await tracker.start();

    currentUser<ILSUser>()
      .pipe(distinctUntilChanged())
      .subscribe(user => (user ? tracker.setUserID(user.email) : undefined));
    // add Google Adwords tags for conversion tracking
    const elem1 = document.createElement('script');
    elem1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-716896371';
    document.body.appendChild(elem1);

    const elem2 = document.createElement('script');
    elem2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', 'AW-716896371');
    `;
    document.body.appendChild(elem2);
  }
};

void startup();
